var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7932 8.30337L15.1806 8.30007C11.5022 8.29127 8.3089 11.28 8.2836 14.9001V19.0691C8.2836 19.9381 8.1736 20.7862 7.6995 21.5089L7.3838 21.9907C6.9031 22.7211 7.4201 23.7001 8.2836 23.7001H23.7166C24.5801 23.7001 25.096 22.7211 24.6164 21.9907L24.3007 21.5089C23.8277 20.7862 23.7166 19.937 23.7166 19.068V14.9012C23.6726 11.28 20.4716 8.31217 16.7932 8.30337V8.30337Z",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3002 23.7C19.3002 24.5752 18.9525 25.4145 18.3336 26.0334C17.7148 26.6523 16.8754 26.9999 16.0002 26.9999C15.125 26.9999 14.2856 26.6523 13.6667 26.0334C13.0479 25.4145 12.7002 24.5752 12.7002 23.7",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 5C16.5838 5 17.1433 5.23178 17.5559 5.64436C17.9685 6.05694 18.2003 6.61652 18.2003 7.2V8.3H13.8003V7.2C13.8003 6.61652 14.0321 6.05694 14.4447 5.64436C14.8572 5.23178 15.4168 5 16.0003 5Z",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.f750fa851bbd03ae2da456b15ae70039.svg";
export { ForwardRef as ReactComponent };